"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査対象事業基本情報欄
 * @prop {object} [data] - 監査対象事業基本情報
 * @prop {string} [data.kansaTgtNendoNm] - 監査対象年度名
 * @prop {string} [data.kansaThemeNm] - 監査テーマ
 * @prop {string} [data.kansaBumonNm] - 監査部門
 * @prop {string} [data.kansaSekinishaNm] - 監査部門責任者
 * @prop {string} [data.kansaTgtJigyoNm] - 監査対象事業
 * @prop {string} [data.hikansaSekinishaNm] - 被監査部門責任者
 */
const KansaTgtJigyoBasicInfo = _ref => {
  let {
    intl,
    data = {
      kansaTgtNendoNm: '',
      kansaThemeNm: '',
      kansaBumonNm: '',
      kansaSekinishaNm: '',
      kansaTgtJigyoNm: '',
      hikansaSekinishaNm: ''
    }
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_YEAR
    }),
    value: _stringUtil.default.emptyToHyphen(data.kansaTgtNendoNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_THEME
    }),
    value: _stringUtil.default.emptyToHyphen(data.kansaThemeNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    }),
    value: _stringUtil.default.emptyToHyphen(data.kansaBumonNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_SEKININSHA
    }),
    value: _stringUtil.default.emptyToHyphen(data.kansaSekinishaNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_BUSINESS
    }),
    value: _stringUtil.default.emptyToHyphen(data.kansaTgtJigyoNm)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HIKANSA_SEKININSHA
    }),
    value: _stringUtil.default.emptyToHyphen(data.hikansaSekinishaNm)
  })));
};
KansaTgtJigyoBasicInfo.propTypes = {
  data: _propTypes.default.shape({
    kansaTgtNendoNm: _propTypes.default.string,
    kansaThemeNm: _propTypes.default.string,
    kansaBumonNm: _propTypes.default.string,
    kansaSekinishaNm: _propTypes.default.string,
    kansaTgtJigyoNm: _propTypes.default.string,
    hikansaSekinishaNm: _propTypes.default.string
  })
};
var _default = exports.default = (0, _reactIntl.injectIntl)(KansaTgtJigyoBasicInfo);